import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponse } from '../api-models-base.interface';
import { IResponseMemberShipPoints } from './membership-api.model.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export const URL_MEMBERSHIP = environment.host + '/Membership'
//export const URL_MEMBERSHIP = 'https://mocki.io/v1/c841e097-4a0d-4a39-b40e-cf87475fcaa3'

@Injectable({
  providedIn: 'root'
})
export class MembershipApiService {

  constructor(private _httpClient: HttpClient) { }

    searchPoints(ci: string): Observable<IResponse<IResponseMemberShipPoints>> {
      const url = `${URL_MEMBERSHIP}/${ci}`;
      return this._httpClient.get<IResponse<IResponseMemberShipPoints>>(url);
    } 

   
}
